import React, { Component } from "react";
import styles from "./driverUnitsBar.module.scss";
import { withCars } from "../../../../shared/containers/containerCars";
import CarsSecondSideBar from "../../../sections/secondSideBars/carsSecondSideBar";
import SideBarInner from "../../../../shared/sideBarInner";
import CarsTitleBar from "../../../sections/cars/carsTitleBar";
import CarsSortPanel from "../../../sections/cars/carsSortPanel";
import SideBar from "../../../sides/sideBar";
import CarsTitleClosedBar from "../../../sections/cars/carsTitleClosedBar";
import CarsPaginationSettingsPanel from "../../../sections/cars/carsPaginationSettingsPanel";
import DriverUnitsListWrapper from "./DriverUnitsListWrapper";

class DriverUnitsBar extends Component {
  render() {
    return (
      <div>
        <SideBar TitleClosed={<CarsTitleClosedBar />}>
          <div className={styles.userUnitsBar}>
            <SideBarInner>
              <CarsTitleBar />
            </SideBarInner>

            <SideBarInner>
              <CarsSortPanel />
            </SideBarInner>

            <SideBarInner>
              <div className={styles.inLineContainer}>
                <CarsPaginationSettingsPanel />
                <div
                  className={styles.container_params}
                  onClick={(e) => {
                    e.stopPropagation();
                    /*   if (toAction.length === 0) {
                      this.onClickHandler();
                    } */
                  }}
                ></div>
              </div>

              <div className={styles.container_userUnitsList}>
                <DriverUnitsListWrapper />
              </div>
            </SideBarInner>
          </div>
        </SideBar>
        <CarsSecondSideBar />
      </div>
    );
  }
}

export default withCars(React.memo(DriverUnitsBar));
